import React, { useState } from 'react';
import { Brain, Apple } from 'lucide-react';
import ElencoQuestionari from './ElencoQuestionari';
import '../../styles/Questionari.css';
import '../../styles/QuestionariConsole.css';

/**
 * ProfiloAlimentareTab — contiene il profilo psicologico e quello
 * alimentare, che si leggono insieme.
 *
 * Il profilo alimentare non ha ancora strumenti caricati. La schermata lo
 * dice: un riquadro vuoto senza spiegazione fa pensare a un guasto, e un
 * segnaposto con dati di esempio e' peggio ancora - su questo gestionale
 * e' gia' successo con il riquadro Longevity, che ha vissuto mesi con
 * valori inventati.
 */

const SEZIONI = [
    { id: 'psicologico', label: 'Profilo psicologico', icon: Brain },
    { id: 'alimentare',  label: 'Profilo alimentare',  icon: Apple },
];

const ProfiloAlimentareTab = ({ pazienteId, apriCompilazione = null }) => {
    const [sezione, setSezione] = useState('psicologico');
    const attiva = SEZIONI.find((s) => s.id === sezione);

    return (
        <div className="pa-wrap">
            <div className="pa-barra">
                {SEZIONI.map((s) => {
                    const Icona = s.icon;
                    return (
                        <button key={s.id}
                                className={`pa-btn ${sezione === s.id ? 'attivo' : ''}`}
                                onClick={() => setSezione(s.id)}
                                title={s.label}>
                            <Icona size={20} />
                        </button>
                    );
                })}
            </div>

            <div className="pa-etichetta">{attiva?.label}</div>

            {sezione === 'psicologico' ? (
                <ElencoQuestionari pazienteId={pazienteId} area="psicologico"
                                   apriCompilazione={apriCompilazione} />
            ) : (
                <div className="qz-vuoto">
                    <Apple size={32} strokeWidth={1.4} />
                    <p><strong>Nessuno strumento caricato per il profilo alimentare.</strong></p>
                    <p className="qz-vuoto-nota">
                        Questa sezione funziona come il profilo psicologico: i questionari
                        si caricano da file e si somministrano dal tablet. Quando ce ne
                        saranno, compariranno qui.
                    </p>
                </div>
            )}
        </div>
    );
};

export default ProfiloAlimentareTab;
